export default __webpack_public_path__ + "img/27c51771a9d4ac89cad1cd08eb8ba946.svg";